import Axios from "axios";
import {
    SET_SAMPLE_ORDER_LIST,
    UNSET_SAMPLE_ORDER_LIST,
} from "@/store/mutation-types";
import {
    saveUpdateSampleOrder,
    getSampleOrderList,
    getSampleOrderById,
} from "@/store/api";
// initial state
const state = {
    getSampleOrderList: [],
    editingSampleOrder: null,
    viewingSampleOrder: null,
};

const getters = {
    getSampleOrderList(state) {
        return state.getSampleOrderList;
    },
    getEditingSampleOrder: (state) => state.editingSampleOrder,
    getViewingSampleOrder: (state) => state.viewingSampleOrder,
};

const mutations = {
    [SET_SAMPLE_ORDER_LIST](state, data) {
        state.getSampleOrderList = data;
    },
    [UNSET_SAMPLE_ORDER_LIST](state) {
        state.getSampleOrderList = [];
    },
    setEditingSampleOrder(state, lead) {
        state.editingSampleOrder = lead;
    },
    setViewingSampleOrder(state, lead) {
        state.viewingSampleOrder = lead;
    },
};

const actions = {
    saveUpdateSampleOrder({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSampleOrder, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSampleOrderList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getSampleOrderList, data)
                .then(function (response) {
                    commit("SET_SAMPLE_ORDER_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_SAMPLE_ORDER_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSampleOrderById({ commit }, data) {
        const getSampleOrderByIdApi = `${getSampleOrderById}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSampleOrderByIdApi)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    commit("UNSET_SAMPLE_ORDER_LIST");
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
